'use strict';

var Transitionable = function(){};

Transitionable.prototype = {
    enterTransition: null,
    exitTransition: null,
    getElement: null,
    setExitParticipant: null
};

module.exports = Transitionable;


//////////////////
// WEBPACK FOOTER
// ./mits/Events/Transitionable.js
// module id = 12
// module chunks = 0